import React, { Fragment, useState } from "react";
import {
  faTimes,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InviteStudent.css";
import "../AdminPages.css";
import GetAdminService from "../../../services/admin/GetAdminService";
import swal from "sweetalert";

const InviteCounselor = ({ setOpenInviteCounselor, schoolId }) => {
  const [emailError, setEmailError] = useState(true);
  const [email, setEmail] = useState();
  const [counselorId, setCounselorId] = useState();

  const sendEmail = () => {
    let obj = {
      email: email,
      school: schoolId,
      role: "counselor",
    };
    if (obj.role == "counselor") {
      obj.counselor = counselorId;
    }
    GetAdminService.sendCounselorEmail(obj)
      .then(() => {
        swal({
          title: "Successfully",
          text: "Email send successfully",
          icon: "success",
          dangerMode: true,
          buttons: {
            ok: true,
          },
          closeOnClickOutside: true,
        });
      })
      .catch((error) => {
        swal({
          title: "Oops!!",
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
          },
          closeOnClickOutside: true,
        });
      });
    setEmailError(true);
    setEmail("");
  };

  const handleEmail = (e) => {
    setEmail(e.target.value.toLowerCase());
    if (e.target.value.match("[a-z0-9]+@[a-z]+\\.[a-z]{2,3}"))
      setEmailError(false);
    else {
      setEmailError(true);
    }
  };

  return (
    <Fragment>
      <div className="goal-full-container">
        <div className="drawer-header">
          <h3 className="drawer-title">Invite Counselor</h3>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => setOpenInviteCounselor(false)}
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Contact</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Email
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleEmail}
              />
            </div>
          </div>
        </div>

        <div className="drawer-footer">
          <button
            type="button"
            className="drawer-btn-save"
            onClick={sendEmail}
            disabled={emailError}
          >
            <FontAwesomeIcon icon={faPaperPlane} />
            Invite
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default InviteCounselor;
